"use strict";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _Popup = _interopRequireDefault(require("./components/Popup"));

var _const = require("./const");

var _style = require("./style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/**
 * CustomSelect. Component uses react-select library for customization.
 */


var CustomSelect = function CustomSelect(_ref) {
  var _ref$isCustom = _ref.isCustom,
      isCustom = _ref$isCustom === void 0 ? false : _ref$isCustom,
      _ref$isPopup = _ref.isPopup,
      isPopup = _ref$isPopup === void 0 ? false : _ref$isPopup,
      _ref$relative = _ref.relative,
      relative = _ref$relative === void 0 ? false : _ref$relative,
      _ref$configuration = _ref.configuration,
      configuration = _ref$configuration === void 0 ? {} : _ref$configuration,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? _const.ALIGN_HORIZONTAL : _ref$align,
      _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? false : _ref$compact,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      otherProps = _objectWithoutProperties(_ref, ["isCustom", "isPopup", "relative", "configuration", "align", "compact", "onChange"]);

  var handleChange = function handleChange(option) {
    onChange(option);
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react.Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement(_style.StyledSelectBox, {
      compact: compact,
      align: align,
      relative: relative
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactSelect["default"], _extends({
      align: align,
      onChange: handleChange,
      styles: isCustom ? _style.CustomStyles : _style.InputStyles,
      components: isCustom ? {
        Menu: _Popup["default"]
      } : null
    }, otherProps))))
  );
};

var _default = CustomSelect;
exports["default"] = _default;